import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useEST(data = {}) {
  const { enabled = false, queryParams = '', estID } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getESTDetails() {
    return privateFetch.get(`/v1/admin/est/${estID}${queryParams}`).then((res) => res.data);
  }

  return useQuery(['est-details', estID, { data }], getESTDetails, { enabled });
}

export default useEST;
